import { render, staticRenderFns } from "./PainterUpdates.vue?vue&type=template&id=3641ec6f&scoped=true"
import script from "./PainterUpdates.vue?vue&type=script&lang=js"
export * from "./PainterUpdates.vue?vue&type=script&lang=js"
import style0 from "./PainterUpdates.vue?vue&type=style&index=0&id=3641ec6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641ec6f",
  null
  
)

export default component.exports